<div class="business-navbar__location-list-item__container"
     [class.business-navbar__location-list-item__container--active]="isActive"
     [class.business-navbar__location-list-item__container--current-location]="isCurrentLocation">
    <a *ngIf="!isCurrentLocation && serviceProviderId !== 'VBC'"
       class="business-navbar__location-list-item"
       (click)="goToLocation($event)"
       [href]="target$ | async"
    >
        <ng-content *ngTemplateOutlet="item"></ng-content>
    </a>

    <a *ngIf="!isCurrentLocation && serviceProviderId.toUpperCase() === 'VBC'"
       (click)="goToLocation($event)"
       [routerLink]="target$ | async"
       class="business-navbar__location-list-item">
        <ng-content *ngTemplateOutlet="item"></ng-content>
    </a>

    <div *ngIf="isCurrentLocation" class="business-navbar__location-list-item">
        <ng-content *ngTemplateOutlet="item"></ng-content>
    </div>

    <div class="business-navbar__location-list-item__kebab-button">
        <i class="material-icons business-navbar__location-list-item__icon business-navbar__location-list-item__kebab-button__icon">more_vert</i>
        <atlas-menu>
            <div>
                <ng-container *ngIf="!!location.accountGroup">
                    <atlas-menu-item [label]="'SWITCH_LOCATION_MODAL.SELECT_LOCATION' | translate:'Select Location'"
                                     (click)="goToLocation($event)"
                                     [disabled]="isCurrentLocation"
                                     [url]="serviceProviderId.toUpperCase() !== 'VBC' ? (target$ | async) : null"
                                     [route]="serviceProviderId.toUpperCase() === 'VBC' ? (target$ | async) : null"
                                     icon="swap_horiz">
                    </atlas-menu-item>
                    <atlas-menu-item *ngIf="(dataService.defaultLocation$ | async) !== location.accountGroup.accountGroupId"
                                     [label]="'SWITCH_LOCATION_MODAL.MAKE_DEFAULT' | translate:'Make Default'"
                                     icon="bookmark"
                                     (click)="setDefaultLocation(location.accountGroup.accountGroupId)">
                    </atlas-menu-item>
                </ng-container>
                <ng-container *ngIf="!!location.brand">
                    <atlas-menu-item [label]="'SWITCH_LOCATION_MODAL.SELECT_LOCATION' | translate:'Select Location'"
                                     (click)="goToLocation($event)"
                                     [disabled]="isCurrentLocation"
                                     [url]="serviceProviderId.toUpperCase() !== 'VBC' ? (target$ | async) : null"
                                     [route]="serviceProviderId.toUpperCase() === 'VBC' ? (target$ | async) : null"
                                     icon="swap_horiz">
                    </atlas-menu-item>
                </ng-container>
            </div>
        </atlas-menu>
    </div>
</div>

<ng-template #item>
    <svg *ngIf="!!location.brand && !isCurrentLocation" class="material-icons business-navbar__location-list-item__icon"
         version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
         viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
        <g>
            <path d="M22.5,6.3h-16v2h16V6.3z M23.5,16.3v-2l-1-5h-16l-1,5v2h1v6h10v-6h4v6h2v-6H23.5z M14.5,20.3h-6v-4h6V20.3z"/>
            <path d="M17.6,1.3h-16v2h16V1.3z M5.7,5.3l12.3,0.1l-0.3-1.1h-16l-1,5v2h1v6h3v-2l-1,0v-4l1.6,0l0.5-2.2L5.7,5.3z"/>
        </g>
    </svg>
    <i *ngIf="!!location.accountGroup && !isCurrentLocation"
       class="material-icons business-navbar__location-list-item__icon">store</i>
    <i *ngIf="!!isCurrentLocation" class="material-icons business-navbar__location-list-item__icon">check</i>
    <div *ngIf="!!location.accountGroup" class="business-navbar__location-list-item__business-details">
        <div class="business-navbar__location-list-item__business-details__name">{{ location.accountGroup.name }}</div>
        <div class="business-navbar__location-list-item__business-details__address">{{ location.accountGroup.address }}</div>
    </div>
    <div *ngIf="!!location.brand" class="business-navbar__location-list-item__business-details">
        <div class="business-navbar__location-list-item__business-details__name">{{ location.brand.name }}</div>
        <div class="business-navbar__location-list-item__business-details__address">Brand</div>
    </div>
    <atlas-chip
            *ngIf="!!location.accountGroup && (dataService.defaultLocation$ | async) === location.accountGroup.accountGroupId"
            [isDefaultChip]="true" [text]="'SWITCH_LOCATION_MODAL.DEFAULT' | translate:'DEFAULT'"></atlas-chip>
    <atlas-icon *ngIf="hasProduct$ | async" [logoUrl]="logoUrl$ | async"></atlas-icon>
</ng-template>
